if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"equinoxStorefront","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(18(3|54)|4677|5055|7329|8957)|2(3395|6263|6300)|4((10|41)89|3912|5882|5907)|5((155|451|693)8|(286|846|949)3|2289|4295|9109)|6(6388|781|929)|8(4([67]37|716)|2543|3481|3568|759|8285)|9(80(5|67)|5925|6356|677|9893)|36342|37241|73269|75091)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}